import React from 'react';
import { Switch } from '@headlessui/react';

export const Toggle = ({ label, checked, onChange, disabled }) => {
  return (
    <div className="flex items-center justify-between px-3 py-2 rounded-lg ">
      <span className="text-sm font-medium text-white/80 dark:text-white mr-3">
        {label}
      </span>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`${
          checked ? 'bg-[#1D4ED8]' : 'bg-gray-400/50 dark:bg-gray-600/40'
        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </Switch>
    </div>
  );
};
